<script>
export default {
  name: "confirmationSelection",
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    redirectToHome() {
      this.$router.push({ path: "/homepage" });
    }
  }
};
</script>

<template>
  <el-row style="padding: 20px 15px 20px 15px; background-color: #ffffff">
    <el-col :span="24">
      <el-row>
        <el-col :span="24">
          <span class="title-confirmation-selection">Congratulations!</span>
        </el-col>
        <el-col
          :span="24"
          style="margin-top: 20px; display: flex; justify-content: center"
        >
          <el-image
            :src="require('../../assets/similar-search-1.jpg')"
            fit="fill"
            style="max-height: 582px; max-width: 1544px; border-radius: 0 0 20px 20px; box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-row>
            <el-col :span="24" style="margin-top: 10px">
              <el-row>
                <span class="para-confirmation-selection"
                  >Congratulations on taking the first step in your property
                  purchase.</span
                >
              </el-row>
            </el-col>
            <el-col :span="24" style="margin-top: 10px">
              <span class="para-confirmation-selection"
                >Your agent will be in touch with you shortly to discuss the
                next steps.</span
              >
            </el-col>
            <el-col
              :span="24"
              style="margin-top: 20px; display: flex; flex-direction: column"
            >
              <el-button class="btn-return-home" @click="redirectToHome"
                >Return Home</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.title-confirmation-selection {
  color: #003333;
  align-self: start;
  font: 600 34px/117.647% DINosaur-a, sans-serif;
  display: flex;
  justify-content: center;
}

.para-confirmation-selection {
  color: #003333;
  align-self: start;
  font: 400 18px/111.111% DINosaur-a, sans-serif;
  display: flex;
  justify-content: center;
  text-align: center;
}

.btn-return-home {
  border-top-right-radius: 30px;
  border: 3px solid #003333;
  background-color: #003333;
  color: #ffffff;
  text-align: center;
  padding: 10px 0;
  font: 400 22px/125% DINosaur-a, sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/components/reservation/confirmationSelection.vue